/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationCondition } from './AutomationCondition';
import {
    AutomationConditionFromJSON,
    AutomationConditionFromJSONTyped,
    AutomationConditionToJSON,
    AutomationConditionToJSONTyped,
} from './AutomationCondition';
import type { AutomationActionConfig } from './AutomationActionConfig';
import {
    AutomationActionConfigFromJSON,
    AutomationActionConfigFromJSONTyped,
    AutomationActionConfigToJSON,
    AutomationActionConfigToJSONTyped,
} from './AutomationActionConfig';

/**
 * 
 * @export
 * @interface UpdateAutomationRuleRequest
 */
export interface UpdateAutomationRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAutomationRuleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAutomationRuleRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAutomationRuleRequest
     */
    triggerType?: UpdateAutomationRuleRequestTriggerTypeEnum;
    /**
     * 
     * @type {Array<AutomationCondition>}
     * @memberof UpdateAutomationRuleRequest
     */
    conditions?: Array<AutomationCondition>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAutomationRuleRequest
     */
    actionType?: UpdateAutomationRuleRequestActionTypeEnum;
    /**
     * 
     * @type {AutomationActionConfig}
     * @memberof UpdateAutomationRuleRequest
     */
    actionConfig?: AutomationActionConfig;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAutomationRuleRequest
     */
    isActive?: boolean;
}


/**
 * @export
 */
export const UpdateAutomationRuleRequestTriggerTypeEnum = {
    ClaimCreated: 'claim_created'
} as const;
export type UpdateAutomationRuleRequestTriggerTypeEnum = typeof UpdateAutomationRuleRequestTriggerTypeEnum[keyof typeof UpdateAutomationRuleRequestTriggerTypeEnum];

/**
 * @export
 */
export const UpdateAutomationRuleRequestActionTypeEnum = {
    SendForm: 'send_form'
} as const;
export type UpdateAutomationRuleRequestActionTypeEnum = typeof UpdateAutomationRuleRequestActionTypeEnum[keyof typeof UpdateAutomationRuleRequestActionTypeEnum];


/**
 * Check if a given object implements the UpdateAutomationRuleRequest interface.
 */
export function instanceOfUpdateAutomationRuleRequest(value: object): value is UpdateAutomationRuleRequest {
    return true;
}

export function UpdateAutomationRuleRequestFromJSON(json: any): UpdateAutomationRuleRequest {
    return UpdateAutomationRuleRequestFromJSONTyped(json, false);
}

export function UpdateAutomationRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAutomationRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'triggerType': json['triggerType'] == null ? undefined : json['triggerType'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(AutomationConditionFromJSON)),
        'actionType': json['actionType'] == null ? undefined : json['actionType'],
        'actionConfig': json['actionConfig'] == null ? undefined : AutomationActionConfigFromJSON(json['actionConfig']),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateAutomationRuleRequestToJSON(json: any): UpdateAutomationRuleRequest {
    return UpdateAutomationRuleRequestToJSONTyped(json, false);
}

export function UpdateAutomationRuleRequestToJSONTyped(value?: UpdateAutomationRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'triggerType': value['triggerType'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(AutomationConditionToJSON)),
        'actionType': value['actionType'],
        'actionConfig': AutomationActionConfigToJSON(value['actionConfig']),
        'isActive': value['isActive'],
    };
}

